import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28, ...props }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay }}
    {...props}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light = false }) => (
  <p
    className={`mb-4 inline-flex items-center gap-2.5 text-xs font-bold uppercase tracking-[0.22em] ${
      light ? "text-orange-400" : "text-orange-600"
    }`}
  >
    <span className="h-px w-8 bg-orange-500" aria-hidden="true" />
    {children}
  </p>
);
